export const promoCodePath = '/code'
export const promoCodeAcceptedPath = '/code-accepted'

export const promoCodeSearchParam = 'promocode'
